import type { ButtonTokens } from './types';

export const button: ButtonTokens = {
  colors: {
    primary: {
      bgColor: 'primary.50',
      color: 'neutral.0',
      hover: {
        bgColor: 'primary.30',
        color: 'neutral.0',
      },
      active: {
        bgColor: 'primary.30',
        color: 'neutral.0',
      },
      disabled: {
        bgColor: 'neutral.30',
        color: 'neutral.50',
      },
      inverted: {
        bgColor: 'neutral.0',
        color: 'primary.50',
        hover: {
          bgColor: 'primary.20',
          color: 'primary.70',
        },
        active: {
          bgColor: 'primary.20',
          color: 'primary.70',
        },
        disabled: {
          bgColor: 'neutral.30',
          color: 'neutral.60',
        },
      },
    },
    secondary: {
      color: 'primary.50',
      bgColor: 'neutral.0',
      hover: {
        bgColor: 'primary.20',
        color: 'primary.50',
      },
      active: {
        bgColor: 'primary.20',
        color: 'primary.50',
      },
      disabled: {
        bgColor: 'neutral.30',
        color: 'neutral.50',
      },
      inverted: {
        color: 'neutral.0',
        bgColor: null,
        active: null,
        hover: null,
        disabled: {
          color: 'neutral.30',
        },
      },
    },
    text: {
      color: 'primary.50',
      bgColor: null,
      hover: {
        color: 'primary.70',
        bgColor: 'primary.20',
      },
      active: {
        color: 'primary.70',
        bgColor: 'primary.20',
      },
      disabled: {
        color: 'neutral.50',
      },
      inverted: {
        color: 'neutral.0',
        bgColor: null,
        active: null,
        hover: {
          color: 'neutral.0',
          bgColor: 'neutral.0',
        },
        disabled: {
          color: 'neutral.30',
        },
      },
    },
    /**
     * @deprecated
     * use primary instead
     */
    highlight: {
      bgColor: 'primary.50',
      color: null,
      hover: {
        bgColor: 'primary.30',
      },
      active: {
        bgColor: 'primary.30',
        color: 'primary.20',
      },
      disabled: {
        bgColor: 'neutral.30',
        color: 'neutral.50',
      },
      inverted: null,
    },
    positive: {
      color: null,
      bgColor: 'green.50',
      hover: { bgColor: 'green.70' },
      active: { bgColor: 'green.30' },
      disabled: null,
      inverted: null,
    },
    warning: {
      color: null,
      bgColor: 'orange.50',
      hover: { bgColor: 'orange.70' },
      active: { bgColor: 'orange.30' },
      disabled: null,
      inverted: null,
    },
    critical: {
      color: null,
      bgColor: 'red.50',
      hover: { bgColor: 'red.70' },
      active: { bgColor: 'red.30' },
      disabled: null,
      inverted: null,
    },
    deal: null,
  },
  space: {
    small: {
      px: 'base',
      py: '1x_small',
    },
    medium: {
      px: 'big',
      py: 'small',
    },
    large: {
      px: '1x_big',
      py: 'base',
    },
  },
  radii: 42,
  opacity: '1',
};
